<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item md-size-100 md-small-size-100">
        <h6>Selecciona el tipo de incidencia de calidad o packaging de los productos</h6>

        <div class="md-layout-item md-size-100 md-small-size-100 table-container">
          <table class="producto-table" :key="product_table">
            <thead>
              <tr>
                <th>
                  <label class="md-table-head-label">Si todos los productos están afectados</label>
                </th>
                <th style="padding:12px 8px">
                  <md-field>
                    <label for="tipo">Selecciona la incidencia</label>
                    <md-select v-model="tipo_general" name="tipo" @md-selected="copyToAll">
                      <md-optgroup label="Logística">
                        <md-option value="Horario de entrega">Horario de entrega</md-option>
                        <md-option value="Calendario de entrega">Calendario de entrega</md-option>
                        <md-option value="Fecha Corta">Fecha Corta</md-option>
                        <md-option value="Producto Roto (caja)">Producto Roto (caja)</md-option>
                        <md-option value="Temperatura de llegada">Temperatura de llegada</md-option>
                      </md-optgroup>
                      <md-optgroup label="Calidad">
                        <md-option value="Producto dañado">Producto dañado</md-option>
                        <md-option value="Parásito">Parásito</md-option>
                        <md-option value="Cuerpo extraño">Cuerpo extraño</md-option>
                        <md-option value="Oxidación">Oxidación</md-option>
                        <md-option value="Aguado Húmedo">Aguado Húmedo</md-option>
                        <md-option value="Fuera de Calibre">Fuera de Calibre</md-option>
                        <md-option value="Análisis Microbiológico">Análisis Microbiológico</md-option>
                        <md-option value="Análisis Físico Químico">Análisis Físico Químico</md-option>
                        <md-option value="Proporciones (receta)">Proporciones (receta)</md-option>
                        <md-option value="Podredumbre / Moho">Podredumbre / Moho</md-option>
                        <md-option value="Organolépticos">Organolépticos</md-option>
                      </md-optgroup>
                      <md-optgroup label="Packaging">
                        <md-option value="Producto Roto (envase)">Producto Roto (envase)</md-option>
                        <md-option
                          value="Impresión fecha caducidad / lote"
                        >Impresión fecha caducidad / lote</md-option>
                        <md-option value="Envase incorrecto">Envase incorrecto</md-option>
                        <md-option value="Unidades / caja">Unidades / caja</md-option>
                        <md-option value="Peso neto">Peso neto</md-option>
                        <md-option value="Etiqueta caja">Etiqueta caja</md-option>
                      </md-optgroup>
                      <md-optgroup label="Financiera">
                        <md-option value="Financiera">Financiera</md-option>
                      </md-optgroup>
                      <md-optgroup label="Call Center">
                        <md-option value="Call Center">Call Center</md-option>
                      </md-optgroup>
                    </md-select>
                  </md-field>
                </th>
              </tr>
              <tr class="producto-table-header">
                <th style="width:40%">
                  <div class="md-table-head-label">Producto</div>
                </th>
                <th style="width:15%">
                  <div class="md-table-head-label">Incidencia</div>
                </th>
                <th style="width:10%; text-align: right;">
                  <div class="md-table-head-label">Unidad</div>
                </th>
                <th style="width:10%; text-align: right;">
                  <div class="md-table-head-label">Cantidad</div>
                </th>
                <th style="width:10%; text-align: right;">
                  <div class="md-table-head-label">Afectadas</div>
                </th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(item, i) in issue.selectedProductos" :key="i">
                <td style="width:30%">
                  {{ item.producto.codigo }}
                  <br />
                  <small>{{ item.producto.descripcion_corta }}</small>
                </td>
                <td style="width:30%">
                  <md-field
                    :class="[
                      {'md-valid': itemHasIncidencia(item)},
                      {'md-error': !itemHasIncidencia(item)}]"
                  >
                    <label for="tipo">Selecciona la incidencia</label>
                    <md-select v-model="item.incidencia.tipo" name="tipo">
                      <md-optgroup label="Logística">
                        <md-option value="Horario de entrega">Horario de entrega</md-option>
                        <md-option value="Calendario de entrega">Calendario de entrega</md-option>
                        <md-option value="Fecha Corta">Fecha Corta</md-option>
                        <md-option value="Producto Roto (caja)">Producto Roto (caja)</md-option>
                        <md-option value="Temperatura de llegada">Temperatura de llegada</md-option>
                      </md-optgroup>
                      <md-optgroup label="Calidad">
                        <md-option value="Producto dañado">Producto dañado</md-option>
                        <md-option value="Parásito">Parásito</md-option>
                        <md-option value="Cuerpo extraño">Cuerpo extraño</md-option>
                        <md-option value="Oxidación">Oxidación</md-option>
                        <md-option value="Aguado Húmedo">Aguado Húmedo</md-option>
                        <md-option value="Fuera de Calibre">Fuera de Calibre</md-option>
                        <md-option value="Análisis Microbiológico">Análisis Microbiológico</md-option>
                        <md-option value="Análisis Físico Químico">Análisis Físico Químico</md-option>
                        <md-option value="Proporciones (receta)">Proporciones (receta)</md-option>
                        <md-option value="Podredumbre / Moho">Podredumbre / Moho</md-option>
                        <md-option value="Organolépticos">Organolépticos</md-option>
                      </md-optgroup>
                      <md-optgroup label="Packaging">
                        <md-option value="Producto Roto (envase)">Producto Roto (envase)</md-option>
                        <md-option
                          value="Impresión fecha caducidad / lote"
                        >Impresión fecha caducidad / lote</md-option>
                        <md-option value="Envase incorrecto">Envase incorrecto</md-option>
                        <md-option value="Unidades / caja">Unidades / caja</md-option>
                        <md-option value="Peso neto">Peso neto</md-option>
                        <md-option value="Etiqueta caja">Etiqueta caja</md-option>
                      </md-optgroup>
                      <md-optgroup label="Financiera">
                        <md-option value="Financiera">Financiera</md-option>
                      </md-optgroup>
                      <md-optgroup label="Call Center">
                        <md-option value="Call Center">Call Center</md-option>
                      </md-optgroup>
                    </md-select>
                  </md-field>
                </td>
                <td style="width:10%; text-align: right;">{{ item.producto.contenido.unidad }}</td>
                <td style="width:10%; text-align: right;">{{ item.cantidad }}</td>
                <td style="width:10%; padding-left:20px;">
                  <md-field
                    :class="[
                      {'md-valid': itemValidUnidadesAfectadas(item)},
                      {'unidades-texto': true},
                      {'md-error': !itemValidUnidadesAfectadas(item)}]"
                  >
                    <md-input
                      v-model="item.cantidad_afectadas"
                      @keypress.stop="preventNumericInput($event, item)"
                    ></md-input>
                    <slide-y-down-transition>
                      <md-icon class="error" v-show="!itemValidUnidadesAfectadas(item)">close</md-icon>
                    </slide-y-down-transition>
                    <slide-y-down-transition>
                      <md-icon class="success" v-show="itemValidUnidadesAfectadas(item)">done</md-icon>
                    </slide-y-down-transition>
                  </md-field>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div
        class="md-layout-item md-size-100 md-small-size-100"
        v-if="issue.otros && issue.rechazar!= 'lodevuelvo'"
      >
        <h6>Explicanos el problema que has tenido.</h6>
        <md-field>
          <label>Descripción de la incidencia</label>
          <md-textarea v-model="issue.observations"></md-textarea>
        </md-field>
      </div>
    </div>
  </div>
</template>
<script>
import { IconCheckbox } from "@/components";
import { SlideYDownTransition } from "vue2-transitions";
import tiposIncidencia from "../tipoIncidencia";

export default {
  name: "incidencia-step",
  components: {
    IconCheckbox,
    SlideYDownTransition,
  },
  props: {
    issue: {
      type: Object,
    },
  },

  data() {
    return {
      componentKey: 0,
      tipo_general: "",
      product_table: 0,
      tiposIncidencia: tiposIncidencia,
    };
  },
  methods: {
    validate() {
      return this.$validator.validateAll().then((res) => {
        for (
          let index = 0;
          index < this.issue.selectedProductos.length;
          index++
        ) {
          const element = this.issue.selectedProductos[index];
          res =
            res &&
            element.incidencia.tipo != null &&
            element.incidencia.tipo != "" &&
            element.cantidad >= element.cantidad_afectadas;
        }
        this.product_table++;
        if (res) this.$emit("on-validated", res);
        return res;
      });
    },
    copyToAll(value) {
      if (value == null) return;
      for (
        let index = 0;
        index < this.issue.selectedProductos.length;
        index++
      ) {
        const element = this.issue.selectedProductos[index];
        element.incidencia.tipo = value;
      }
      this.product_table++;
      this.tipo_general = null;
    },
    preventNumericInput($event, item) {
      var keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        $event.preventDefault();
      }
    },
    itemHasIncidencia(item) {
      return item.incidencia.tipo != null && item.incidencia.tipo != "";
    },
    itemValidUnidadesAfectadas(item) {
      return item.cantidad >= item.cantidad_afectadas;
    },
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
.table-container {
  overflow: auto;
}
.producto-table {
  width: 100%;
  border-spacing: 0;
}
.producto-table tr {
  transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transition-property: background-color, font-weight;
  will-change: background-color, font-weight;
  line-height: 1.75em;
  cursor: pointer;
}
.producto-table td {
  border-top: 1px solid rgb(221, 221, 221);
  color: rgba(0, 0, 0, 0.87);
  padding: 12px 8px;
  font-size: 14px;
  line-height: 18px;
}
.producto-table i {
  font-size: 20px;
  color: #acacac;
}

.producto-table-header th {
  color: rgb(51, 51, 51);
  font-size: 700;
  padding: 12px 8px;
  text-align: left;
}
.checkbox-table {
  margin: 0px;
  font-size: 14px;
}

.table-fixed {
  max-height: 500px;
  overflow: auto;
}
.img-product {
  width: 90px;
  height: 90px;
}
.img-product > img {
  width: 100%;
  height: 100%;
}
.seleccion-horario {
  display: flex;
  justify-content: center;
  justify-items: center;
}
.unidades {
  display: flex;
}
.unidades-texto {
  /*  width: 30%; */
  margin: 9px 0 0;
}

.unidades-texto input {
  text-align: right;
  padding-right: 25px;
  width: 50px;
}
.md-group {
  padding-top: 20px;
}
.col-product {
  width: 30%;
}
.col-und {
  width: 150px;
}
</style>
